import React from 'react'
import PriwallTheme from '../../../config/MpTheme'
import PriwallIconAndText from '../molecule/MpIconAndText'

type ValidationHintProps = {
  isValid: boolean
  text: string
}

const PriwallValidationHint = ({ isValid, text }: ValidationHintProps) => {
  const iconType = isValid ? ('successnew' as const) : ('errornew' as const)
  const color = isValid
    ? PriwallTheme.colors.success.default
    : PriwallTheme.colors.error.default

  return (
    <PriwallIconAndText
      icon={iconType}
      text={text}
      textImageSpace={8}
      width={16}
      height={16}
      color={color}
      typographyProps={{ variant: 'caption', sx: { color: 'primary.dark' } }}
      boxProps={{ sx: { my: 1 } }}
    />
  )
}

export default PriwallValidationHint
